module.exports = __webpack_public_path__ + "img/leftScroll.2b98dfd2.svg";